// Remembers the utm params a visitor arrived with so the self-serve signup can
// credit the campaign (a Food Corridor partner link, say) that brought them.
// Captured on the first navigation of any page load, sent with the onboarding
// token mint and again with the signup, and forgotten once the signup lands.
//
// Last touch in the browser: a newer campaign click replaces what was stored.
// The server keeps the first attribution it receives, so a lead minted under
// one campaign is not re-credited by a later one.
export const SIGNUP_ATTRIBUTION_KEY = 'bottleSignupAttribution'

export const SIGNUP_ATTRIBUTION_TTL_MS = 30 * 24 * 60 * 60 * 1000

export const UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

function firstValue(value) {
  const single = Array.isArray(value) ? value[0] : value
  return typeof single === 'string' ? single.trim() : ''
}

function utmParamsIn(query) {
  const params = {}
  UTM_FIELDS.forEach(field => {
    const value = firstValue(query && query[field])
    if (value) params[field] = value
  })
  return params
}

function readEntry() {
  try {
    return JSON.parse(localStorage.getItem(SIGNUP_ATTRIBUTION_KEY)) || null
  } catch {
    return null
  }
}

function writeEntry(entry) {
  try {
    localStorage.setItem(SIGNUP_ATTRIBUTION_KEY, JSON.stringify(entry))
  } catch {
    // storage unavailable; attribution is best-effort
  }
}

export function clearSignupAttribution() {
  try {
    localStorage.removeItem(SIGNUP_ATTRIBUTION_KEY)
  } catch {
    // storage unavailable; nothing to forget
  }
}

export function captureSignupAttribution(query, now = Date.now()) {
  const params = utmParamsIn(query)
  if (!Object.keys(params).length) return
  writeEntry({ params, captured_at: now })
}

export function storedSignupAttribution(now = Date.now()) {
  const entry = readEntry()
  if (!entry || typeof entry.captured_at !== 'number') return {}
  if (now - entry.captured_at >= SIGNUP_ATTRIBUTION_TTL_MS) {
    clearSignupAttribution()
    return {}
  }
  return utmParamsIn(entry.params)
}
